import { MarketplaceComponentConfig } from '@nocode/types';

export default <MarketplaceComponentConfig>{
  name: 'JPYCTransfer',
  displayName: {
    en: 'JPYCTransfer',
    ja: 'JPYC Transfer',
  },
  icon: 'icon.png',
  defaultWidth: 335,
  defaultHeight: 460,
  resizeX: true,
  resizeY: true,
  props: [
    {
      name: 'useGasless',
      displayName: {
        en: 'Gasless transfer',
        ja: 'ガスレス送金',
      },
      type: 'switch',
      default: false,
    },
    {
      name: 'recipientAddress',
      displayName: {
        en: 'Recipient address',
        ja: '受取人アドレス',
      },
      type: 'text',
    },
    {
      name: 'amount',
      displayName: {
        en: 'Amount (JPYC)',
        ja: '金額 (JPYC)',
      },
      type: 'number',
    },
    {
      name: 'successActions',
      displayName: {
        en: 'Success actions',
        ja: '成功時のアクション',
      },
      type: 'action',
    },
    {
      name: 'failedActions',
      displayName: {
        en: 'Failed actions',
        ja: '失敗時のアクション',
      },
      type: 'action',
    },
  ],
  childComponents: [
    {
      name: 'title',
      displayName: {
        en: 'Title',
        ja: 'タイトル',
      },
      props: [
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'JPYC送金',
        },
      ],
      // styles: {
      //   fontSize: true,
      //   fontWeight: true,
      //   color: true,
      // },
    },
    {
      name: 'paymentButton',
      displayName: {
        en: 'Payment button',
        ja: '支払いボタン',
      },
      props: [
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'JPYC決済',
        },
      ],
      // styles: {
      //   fontSize: true,
      //   fontWeight: true,
      //   color: true,
      //   backgroundColor: true,
      // },
    },
  ],
  // style: {
  //   backgroundColor: true,
  //   borderStyle: true,
  //   borderWidth: true,
  //   borderColor: true,
  //   borderRadius: true,
  // },
};
